import React, { useEffect, useState } from 'react'
import {
  Autocomplete,
  Chip,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import { api } from '../../../../../../services/Main/Api'

const providerLabels = {
  openai: 'OpenAI (GPT)',
  anthropic: 'Anthropic (Claude)',
}

const CondoAIConfig = ({ condoData, setCondoData, error }) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchProviders()
  }, [])

  const fetchProviders = async () => {
    setLoading(true)
    try {
      const res = await api.get('/ai/provider-configs/', { params: { page_size: 100, is_active: true } })
      setOptions(res.data.results || [])
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const selectedOption = options.find(o => o.id === condoData?.ai_provider_config) || null

  return (
    <>
      <Divider sx={{ mb: 3, mt: 5 }} textAlign="center">
        <Typography variant="h6">Configuração de IA</Typography>
      </Divider>
      <Grid container spacing={2} rowSpacing={3}>
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={options}
            loading={loading}
            value={selectedOption}
            onChange={(_, newValue) => {
              setCondoData(prev => ({
                ...prev,
                ai_provider_config: newValue ? newValue.id : null,
              }))
            }}
            getOptionLabel={(option) => {
              const provider = providerLabels[option.provider] || option.provider
              const model = option.default_model ? ` — ${option.default_model}` : ''
              return `${option.name} (${provider}${model})`
            }}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  {option.name}
                </Typography>
                <Chip
                  label={providerLabels[option.provider] || option.provider}
                  size="small"
                  variant="outlined"
                  color={option.provider === 'openai' ? 'success' : 'info'}
                />
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Provedor de IA"
                size="small"
                placeholder="Padrão do sistema"
                helperText={error?.ai_provider_config || 'Selecione um provedor ou deixe vazio para usar o padrão'}
                error={!!error?.ai_provider_config}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {selectedOption ? (
              <>
                Provedor ativo: <strong>{providerLabels[selectedOption.provider] || selectedOption.provider}</strong>
                {selectedOption.default_model && (
                  <> — Modelo: <strong>{selectedOption.default_model}</strong></>
                )}
              </>
            ) : (
              'Usando configuração padrão do sistema.'
            )}
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default CondoAIConfig
